import { jwtDecode } from "jwt-decode";

// Define an interface for the decoded token
interface SectorRole {
    SectorId: number;
    SectorName: string;
    Roles: string[];
}

interface DecodedToken {
  usersectorroles: SectorRole[];
  role: string[],
}

/**
 * Decode jwt bilgisi
 */
const getJwtToken = (): DecodedToken | null => {
    const token = localStorage.getItem("token");
    if (token != null) {
      try {
        const userToken = jwtDecode(token) as DecodedToken;
        return userToken;
      } catch (error) {
        return null;
      }
    }
  
    console.warn("Token not found in localStorage");
    return null;
  }
  

/**
 * User Sektör Role bilgisi
 */
const getUserSectorInfo = (): SectorRole[] | null => {
    const decodedToken = getJwtToken();
    return decodedToken?.usersectorroles || null;
}

/**
 * User Role bilgisi
 */
const getRolesFromToken = (): string[] | null => {
  const token = localStorage.getItem("token");
  if (token != null) {
      try {
          const userToken = jwtDecode(token) as DecodedToken;
          return userToken.role;
      } catch (error) {
          console.error("Error decoding token:", error);
          return null;
      }
  }

  console.warn("Token not found in localStorage");
  return null;
};
export { getJwtToken, getUserSectorInfo , getRolesFromToken}

